import { useQuery } from 'react-query';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useUnipFunnelApi } from 'services/api/unipFunnelAPI';
import { nameToLabelById } from '../../campaigns/services/utils/dropdownUtils';

const emptyArr = [];
export const useFunnelState = funnelId => {
    const { getFunnel } = useUnipFunnelApi();

    const { accountName, id: selectedAccountId } = useAccount();

    const {
        data: rules = emptyArr,
        isLoading,
        isError,
    } = useQuery(['getFunnel', selectedAccountId, funnelId], () => getFunnel(accountName, funnelId), {
        enabled: !!accountName,
        select: data => data?.rules.map(nameToLabelById),
        refetchOnWindowFocus: false,
    });

    return { rules, isLoading, isError };
};
